import tags from "../../../components/tags";
import text from "./text";
import { note } from "../../../components/html";

export default {
  "Authorization Code Grant: step 2": {
    get: {
      tags: [tags.accessTokens],
      summary: text.summary,
      description: `
      GET /oauth
${text.description.summary}

## Second step: handle redirect to your page
Authorization server redirect the user to your page with the following parameters

${note(
  "This request is not made by you but is received from the authentication server."
)}
  
`,
      parameters: [
        {
          name: "token_type",
          in: "query",
          required: true,
          description: "Response type - constant",
          schema: {
            type: "string",
            example: "Bearer"
          }
        },
        {
          name: "expires_in",
          in: "query",
          required: true,
          description: "Client identification key - Identity Key",
          schema: {
            type: "integer",
            example: 3600
          }
        },
        {
          name: "access_token",
          in: "query",
          required: true,
          description:
            "Address to which the authorization code is sent after successful authorization. You must enable the redirect URI in the section `Nastavení integrace`.",
          schema: {
            type: "string",
            example: "Access token"
          }
        },
        {
          name: "refreshToken",
          in: "query",
          required: true,
          description: "Refresh token to access token",
          schema: {
            type: "string",
            example: "Xw7...moVo"
          }
        }
      ],
      security: []
    }
  }
};
